import { useContext } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import { InvoiceManagementContext } from "./InvoiceManagementProvider";

export const InvoiceReasonModify = {
    Undefined: 0,
    WrongCompanyNameAddress: 1,
    AdjustTaxCode: 2,
    AdjustProductInfo: 3,
    AdjustTaxRate: 4,
    AdjustInvoiceValue_FullReturn: 5,
    AdjustInvoiceValue_PartialReturn: 6,
    Replace_WholeInvoice: 7,
};

function InvoiceReasonModal({ show, onClose, onContinue }) {
    const { reasonId, setReasonId } = useContext(InvoiceManagementContext);

    return (
        <CommonModal show={show} onClose={onClose} title="Lập hóa đơn Điều chỉnh/Thay thế" hideOnClose>
            <Wrapper>
                <div className="lst-option">
                    <label htmlFor="">Chọn thông tin cần điều chỉnh:</label>
                    <div className="option-line">
                        <input type="radio" name="wrongCompanyNameAddress" id="wrongCompanyNameAddress" checked={reasonId === InvoiceReasonModify.WrongCompanyNameAddress} onChange={() => setReasonId(InvoiceReasonModify.WrongCompanyNameAddress)} />
                        <label htmlFor="wrongCompanyNameAddress">Thông báo sai Tên công ty, địa chỉ</label>
                    </div>
                    <div className="option-line">
                        <input type="radio" name="adjustTaxCode" id="adjustTaxCode" checked={reasonId === InvoiceReasonModify.AdjustTaxCode} onChange={() => setReasonId(InvoiceReasonModify.AdjustTaxCode)} />
                        <label htmlFor="adjustTaxCode">Điều chỉnh Mã số thuế</label>
                    </div>
                    <div className="option-line">
                        <input type="radio" name="adjustProductInfo" id="adjustProductInfo" checked={reasonId === InvoiceReasonModify.AdjustProductInfo} onChange={() => setReasonId(InvoiceReasonModify.AdjustProductInfo)} />
                        <label htmlFor="adjustProductInfo">Điều chỉnh Thông tin sản phẩm (Tên, đơn vị, giá, số lượng)</label>
                    </div>
                    <div className="option-line">
                        <input type="radio" name="adjustTaxRate" id="adjustTaxRate" checked={reasonId === InvoiceReasonModify.AdjustTaxRate} onChange={() => setReasonId(InvoiceReasonModify.AdjustTaxRate)} />
                        <label htmlFor="adjustTaxRate">Điều chỉnh thuế xuất</label>
                    </div>
                    <hr />
                    <div className="option-line">
                        <input
                            type="radio"
                            name="adjustInvoiceValueFullReturn"
                            id="adjustInvoiceValueFullReturn"
                            checked={reasonId === InvoiceReasonModify.AdjustInvoiceValue_FullReturn}
                            onChange={() => setReasonId(InvoiceReasonModify.AdjustInvoiceValue_FullReturn)}
                        />
                        <label htmlFor="adjustInvoiceValueFullReturn">Điều chỉnh giá trị hóa đơn (Trả toàn bộ sản phẩm)</label>
                    </div>
                    <div className="option-line">
                        <input
                            type="radio"
                            name="adjustInvoiceValuePartialReturn"
                            id="adjustInvoiceValuePartialReturn"
                            checked={reasonId === InvoiceReasonModify.AdjustInvoiceValue_PartialReturn}
                            onChange={() => setReasonId(InvoiceReasonModify.AdjustInvoiceValue_PartialReturn)}
                        />
                        <label htmlFor="adjustInvoiceValuePartialReturn">Điều chỉnh giá trị hóa đơn (Trả một phần sản phẩm)</label>
                    </div>
                    <label htmlFor="">Chọn thông tin cần điều chỉnh:</label>
                    <div className="option-line">
                        <input type="radio" name="replaceWholeInvoice" id="replaceWholeInvoice" checked={reasonId === InvoiceReasonModify.Replace_WholeInvoice} onChange={() => setReasonId(InvoiceReasonModify.Replace_WholeInvoice)} />
                        <label htmlFor="replaceWholeInvoice">Lập hóa đơn thay thế (Thay thế toàn bộ hóa đơn gốc)</label>
                    </div>
                </div>
                <div className="lst-button">
                    <button className="btn btn-danger" onClick={onClose}>
                        Hủy
                    </button>
                    <button className="btn btn-custom" onClick={onContinue}>
                        Tiếp tục
                    </button>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default InvoiceReasonModal;

const Wrapper = styled.div`
    .lst-option label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 8px 0;
    }

    .option-line label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin: 0 0 0 6px;
    }

    .option-line {
        display: flex;
        align-items: center;
        margin: 4px 0;
    }

    .lst-button {
        margin: 12px 0;
        justify-content: center;
        display: flex;
        gap: 12px;
    }

    .lst-button button {
        width: 160px;
    }
`;
